// SFAF field code descriptions from the Standard Frequency Action Format reference (Updated 2/24/2004)
// Used for tooltips in the SFAF form and output display

export const sfafFieldTooltips: Record<string, string> = {
  // Administrative Data
  '005': 'Security Classification',
  '006': 'Security Classification Modification',
  '007': 'Missing Data Indicator',
  '010': 'Type of Action',
  '014': 'Derivative Classification Authority',
  '015': 'Unclassified Data Fields',
  '016': 'Extended Declassification Date',
  '017': 'Downgrading Instructions',
  '018': 'Original Classification Authority',
  '019': 'Reason for Classification',
  '020': 'Proposal References',

  // Proposal References
  '102': 'Agency Serial Number',
  '103': 'IRAC Docket Number',
  '105': 'List Serial Number',
  '106': 'Serial Replaced/Delete Date',
  '107': 'Authorization Date',
  '108': 'Docket Numbers of Older Authorized',

  // Emission Characteristics
  '110': 'Frequency(ies)',
  '111': 'Excluded Frequency Band',
  '112': 'Frequency Separation Criteria',
  '113': 'Station Class',
  '114': 'Emission Designator',
  '115': 'Transmitter Power',
  '116': 'Power Type',
  '117': 'Effective Radiated Power',
  '118': 'Power/ERP Augmentation',

  // Time/Date Information
  '130': 'Time',
  '131': 'Percent Time',
  '140': 'Required Date',
  '141': 'Expiration Date',
  '142': 'Review Date',
  '143': 'Revision Date',
  '144': 'Approval Authority Indicator',
  '145': 'ITU BR Registration',
  '146': 'DCS Trunk ID',
  '147': 'Joint Agencies',
  '151': 'Coordination Indicator',

  // Organizational Information
  '200': 'Agency',
  '201': 'Unified Command',
  '202': 'Unified Command Service',
  '203': 'Bureau',
  '204': 'Command',
  '205': 'Subcommand',
  '206': 'Installation Frequency Manager',
  '207': 'Operating Unit',
  '208': 'User Net/Code',
  '209': 'Area AFC/DoD AFC/Other Organizations',

  // Transmitter Location Data
  '300': 'State/Country (Transmitter)',
  '301': 'Antenna Location (Transmitter)',
  '302': 'Station Control (Transmitter)',
  '303': 'Antenna Coordinates (Transmitter)',
  '304': 'Call Sign (Transmitter)',
  '306': 'Authorized Radius (Transmitter)',

  // Space Stations (Transmitter)
  '315': 'Equatorial Inclination Angle (Transmitter)',
  '316': 'Apogee (Transmitter)',
  '317': 'Perigee (Transmitter)',
  '318': 'Period of Orbit (Transmitter)',
  '319': 'Number of Satellites (Transmitter)',
  '321': 'Power Density',

  // Transmitter Equipment
  '340': 'Equipment Nomenclature (Transmitter)',
  '341': 'Number of Stations / System Name',
  '342': 'Aircraft Nautical Mile Value (Transmitter)',
  '343': 'Equipment Certification Identification Number (Transmitter)',
  '344': 'Off-the-shelf Equipment',
  '345': 'Radar Tunability',
  '346': 'Pulse Duration',
  '347': 'Pulse Repetition Rate',
  '348': 'Intermediate Frequency',
  '349': 'Sidelobe Suppression',

  // Transmitter Antenna Data
  '354': 'Antenna Name (Transmitter)',
  '355': 'Antenna Nomenclature (Transmitter)',
  '357': 'Antenna Gain (Transmitter)',
  '358': 'Antenna Elevation (Transmitter)',
  '359': 'Antenna Feedpoint Height (Transmitter)',
  '360': 'Antenna Horizontal Beamwidth (Transmitter)',
  '361': 'Antenna Vertical Beamwidth (Transmitter)',
  '362': 'Antenna Orientation (Transmitter)',
  '363': 'Antenna Polarization (Transmitter)',
  '373': 'JSC Area Code (Transmitter)',
  '374': 'ITU Region (Transmitter)',

  // Space Stations (Receiver)
  '415': 'Equatorial Inclination Angle (Receiver)',
  '416': 'Apogee (Receiver)',
  '417': 'Perigee (Receiver)',
  '418': 'Period of Orbit (Receiver)',
  '419': 'Number of Satellites (Receiver)',

  // Receiver Location Data
  '400': 'State/Country (Receiver)',
  '401': 'Antenna Location (Receiver)',
  '402': 'Receiver Control',
  '403': 'Antenna Coordinates (Receiver)',
  '404': 'Call Sign (Receiver)',
  '406': 'Authorized Radius (Receiver)',
  '407': 'Path Length',
  '408': 'Repeater Indicator',

  // Receiver Equipment
  '440': 'Equipment Nomenclature (Receiver)',
  '442': 'Aircraft Nautical Mile Value (Receiver)',
  '443': 'Equipment Certification Identification Number (Receiver)',

  // Receiver Antenna Data
  '454': 'Antenna Name (Receiver)',
  '455': 'Antenna Nomenclature (Receiver)',
  '456': 'Antenna Structure Height (Receiver)',
  '457': 'Antenna Gain (Receiver)',
  '458': 'Antenna Elevation (Receiver)',
  '459': 'Antenna Feedpoint Height (Receiver)',
  '460': 'Antenna Horizontal Beamwidth (Receiver)',
  '461': 'Antenna Vertical Beamwidth (Receiver)',
  '462': 'Antenna Orientation (Receiver)',
  '463': 'Antenna Polarization (Receiver)',
  '470': 'Space Station Noise Temperature',
  '471': 'Earth Station System Noise Temperature',
  '472': 'Equivalent Satellite Link Noise Temperature',
  '473': 'JSC Area Code (Receiver)',

  // Supplementary Details
  '500': 'IRAC Notes',
  '501': 'Notes / Free-text Comments',
  '502': 'Description of Requirement',
  '503': 'Agency Free-text Comments',
  '504': 'FAS Agenda or OUS&P Comments',
  '505': 'NATO Pooled Frequency Code Number',
  '506': 'Paired Frequency',
  '511': 'Major Function Identifier',
  '512': 'Intermediate Function Identifier',
  '513': 'Detailed Function Identifier',
  '520': 'Supplementary Details',
  '521': 'Transition and Narrow Band Planning Data',
  '530': 'Authorized Areas',
  '531': 'Authorized States',

  // Other Assignment Identifiers
  '701': 'Frequency Action Officer',
  '702': 'Control/Request Number',
  '704': 'Type of Service',
  '707': 'PACOM Complement / FMSC Function Number',
  '710': 'Host Country Docket Number',
  '711': 'Aeronautical Service Range and Height',
  '715': 'Transmitter FMSC MRFL Number',

  // Additional Information
  '801': 'Coordination Data/Remarks',
  '803': 'Requestor Data',
  '804': 'Tuning Range / Tuning Increments',
  '805': 'Date Response Required',
  '806': 'Indication if Host Nominations Accepts',
  '807': 'Frequencies to be Deleted',
  '901': 'Record Status',
  '903': 'Proposal Status',
  '904': 'Status Date',
  '905': 'Proposal Date Time Group',
  '906': 'Originator',
  '907': 'Validation Status',
  '910': 'Exercise Project',
  '911': 'Date of Last Transaction',
  '924': 'Data Source Indicator',
  '927': 'Date of Entry',
  '928': 'Date of Receipt',
  '950': 'PC ID',
  '952': 'IRAC Security Classification',
  '953': 'IRAC Declassification Date',
  '956': 'Agency Action Number',
  '957': 'Review Year',
  '958': 'Routine Agenda Item',
  '959': 'Circuit Remarks',
  '963': 'FCC File Number',
  '964': 'TX Aircraft Altitude',
  '965': 'Rx Aircraft Altitude',
  '982': 'JCEOI Line Number',
  '983': 'JCEOI Master Net List Name',
  '984': 'Net Frequency Range',
  '985': 'Joint Restricted Frequency List (JRFL)',
  '986': 'Net Tactical Call Word',
  '987': 'Net Tactical Call Sign',
  '988': 'Net Tactical Air Designator (TAD)',
  '989': 'Net Color Word',
  '990': 'Net Color Number',
  '991': 'Net Restoral Priority',
  '992': 'Net Push Number',
  '993': 'Band Usage',
  '994': 'Check Sum',
  '995': 'COMSEC Keymat',
  '996': 'Circuit Type/Line Item/Group Category',
  '997': 'JCEOI Special Net Instructions',
  '998': 'Net Notes',
  '999': 'Guard Requirements',
}
